import * as actionTypes from './actionTypes';

const initialState = {
  selectedState: { label: '', value: '' },
  selectedMarket: { label: '', value: '' },
  showNextLevelTaxonomy: false,
  topLevelTaxonomy: {
    isFetching: false,
    isServiceError: false,
    data: {},
  },
  nextLevelTaxonomy: {
    isFetching: false,
    isServiceError: false,
    data: {},
    parent: {},
  },
  pageStack: [],
  fileDownoadingProgress: {
    showPopup: false,
    fileName: '',
  },
  //newUI
  allFavorites: [],
};

const allResourcesAndFormsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_INITIAL_STATE:
      return initialState;
    case actionTypes.SET_SELECTED_STATE:
      return { ...state, selectedState: action.value };
    case actionTypes.SET_SELECTED_MARKET:
      return { ...state, selectedMarket: action.value };
    case actionTypes.TOP_LEVEL_TAXONOMY_SERVICE_ERROR:
      return {
        ...state,
        topLevelTaxonomy: {
          ...state.topLevelTaxonomy,
          isFetching: false,
          isServiceError: true,
        },
      };
    case actionTypes.REQUEST_TOP_LEVEL_TAXONOMY_DATA:
      return {
        ...state,
        showNextLevelTaxonomy: false,
        topLevelTaxonomy: {
          isFetching: true,
          isServiceError: false,
          data: {},
        },
        pageStack: [],
      };
    case actionTypes.RECEIVE_TOP_LEVEL_TAXONOMY_DATA:
      return {
        ...state,
        showNextLevelTaxonomy: false,
        topLevelTaxonomy: {
          ...state.topLevelTaxonomy,
          isFetching: false,
          isServiceError: false,
          data: action.data,
        },
      };
    case actionTypes.REQUEST_NEXT_LEVEL_TAXONOMY_DATA:
      return {
        ...state,
        nextLevelTaxonomy: {
          ...state.nextLevelTaxonomy,
          isFetching: true,
          isServiceError: false,
        },
      };
    case actionTypes.RECEIVE_NEXT_LEVEL_TAXONOMY_DATA:
      return {
        ...state,
        nextLevelTaxonomy: {
          ...state.nextLevelTaxonomy,
          isFetching: false,
          isServiceError: false,
          data: action.data,
        },
      };
    case actionTypes.NEXT_LEVEL_TAXONOMY_SERVICE_ERROR:
      return {
        ...state,
        nextLevelTaxonomy: {
          ...state.nextLevelTaxonomy,
          isFetching: false,
          isServiceError: true,
        },
      };

    case actionTypes.SET_PARENT_IN_NEXT_LEVEL_TAXONOMY:
      return {
        ...state,
        showNextLevelTaxonomy: true,
        nextLevelTaxonomy: {
          ...state.nextLevelTaxonomy,
          parent: action.parent,
        },
      };

    case actionTypes.ADD_STATE_IN_PAGE_STACK:
      return {
        ...state,
        pageStack: [...state.pageStack, action.state],
      };

    case actionTypes.REMOVE_STATE_IN_PAGE_STACK:
      return {
        ...state,
        showNextLevelTaxonomy: action.showNextLevelTaxonomy,
        pageStack: action.pageStack,
        nextLevelTaxonomy: {
          ...state.nextLevelTaxonomy,
          ...action.nextLevelTaxonomy,
        },
      };
    case actionTypes.SHOW_FILE_PROGRESS_POPUP:
      return {
        ...state,
        fileDownoadingProgress: {
          fileName: action.fileName,
          showPopup: true,
        },
      };

    case actionTypes.HIDE_FILE_PROGRESS_POPUP:
      return {
        ...state,
        fileDownoadingProgress: { ...state.fileDownoadingProgress, showPopup: false },
      };
    case actionTypes.SET_FAVORITES_LIST:
      return {
        ...state,
        allFavorites: action.data,
      };
    default:
      return state;
  }
};

export default allResourcesAndFormsReducer;
